<nav style="height: 4rem;" class="navbar navbar-expand-lg fixed-top" *transloco="let t; read: 'header'">
<!--  <a routerLink="" [routerLinkActive]="['router-link-active']" >
    <img class="header-logo" src="assets/images/logo-mini.png" alt="logo"/>
    <h4 style="color: white">Sahara Soundscapes</h4>
&lt;!&ndash;    <img src="assets/images/fake-logo-sombra.png" alt="SoundScapes Logo" style="height:40px; margin-right:20px;"/>&ndash;&gt;
  </a>-->


  <div style="margin-top: 0.4rem;" *ngIf="config">
    <a class="header-title-link" routerLink="" [routerLinkActive]="['router-link-active']" >
    <img style="margin-bottom: 0.5rem;" class="header-logo" src="{{logoMiniUrl}}" alt="logo" />
    <!-- <span class="header-logo-text">Calímaco {{config['main_name']}}</span> -->
    <span class="header-logo-text">{{config['main_name']}}</span>
    </a>
  </div>




<!-- Seccion colapsada version movil -->
<div class="navbar-toggler row" style="padding: 0% !important;">
  <button style="margin-top: -0.25rem;" class="navbar-toggler" type="button" (click)="toggleSidebar()">
    <i class="fa fa-bars" style="color: white" aria-hidden="true"></i>
  </button>
  <li class="nav-item dropdown" ngbDropdown  display="dynamic" style="padding: 0%;">

    <a href="javascript:void(0)" ngbDropdownToggle>
      <i class="fa fa-fw fa-user"></i>
    </a>
    <div style="margin-right: 1rem !important;right:0;left:auto" class="dropdown-menu" ngbDropdownMenu>
      <a class="dropdown-item" [routerLink]="['/user_profile']" >
        <i class="fa fa-fw fa-user"></i> {{t('my_profile')}}
      </a>
      <a class="dropdown-item" [routerLink]="['/login']" (click)="onClickLoggedout()">
        <i class="fa fa-fw fa-power-off"></i> {{t('logout')}}
      </a>
    </div>
  </li>
</div>
<!-- Seccion normal -->
<div class="collapse navbar-collapse row">

  <ul class="header-link-group navbar-nav">
    <li class="header-link-item nav-item">
      <a routerLink="/explorar" [routerLinkActive]="['header-link-active']"  class="header-link">
         Explorar
      </a>
    </li>
    <li class="nav-item">
      <a routerLink="/archivo" [routerLinkActive]="['header-link-active']" class="header-link">
         Archivo
      </a>
    </li>
    <li class="nav-item">
      <a routerLink="/tablon" [routerLinkActive]="['header-link-active']"  class="header-link">
         Tablón
      </a>
    </li>
    <li class="nav-item">
      <a routerLink="/mis_aportes" [routerLinkActive]="['header-link-active']" class="header-link">
         Mis aportes
      </a>
    </li>
    <li class="nav-item">
      <a routerLink="/mensajes" [routerLinkActive]="['header-link-active']" class="header-link">
         Mensajes
      </a>
      <div *ngIf="unreadCount > 0" class="circle-badge">
        <span class="circle-badge-content">{{this.unreadCount}}</span>
      </div>
    </li>
    <li *ngIf="showItem('moderate')" class="nav-item">
      <a routerLink="/moderar" [routerLinkActive]="['header-link-active']" class="header-link">
         Moderar
      </a>
      <button style="margin-top: -0.25rem;" class="navbar-toggler" type="button" (click)="toggleSidebar()">
        <i class="fa fa-bars" style="color: white" aria-hidden="true"></i>
      </button>
    </li>
    <li *ngIf="showItem('admin')" class="nav-item dropdown" ngbDropdown>
      <a href="javascript:void(0)"  class="header-link" ngbDropdownToggle>
         Administracion <b class="caret"></b>
      </a>
      <div style="margin-right: 1rem !important;right:0;left:auto" class="dropdown-menu" ngbDropdownMenu>
        <a class="dropdown-item" routerLink="/admin/usuarios" [routerLinkActive]="['router-link-active']" >
          <i class="fa fa-fw fa-user"></i> Usuarios
        </a>
        <a class="dropdown-item" routerLink="/admin/stats" [routerLinkActive]="['router-link-active']" >
          <i class="fa fa-fw fa-bar-chart"></i> Estadísticas
        </a>
        <a *ngIf="showItem('ajustes')" class="dropdown-item" routerLink="/admin/ajustes" [routerLinkActive]="['router-link-active']" >
          <i class="fa fa-fw fa-cog"></i> Ajustes
        </a>
      </div>
    </li>
  </ul>

  <ul class="navbar-nav ml-auto">
    <li class="nav-item dropdown" ngbDropdown>
      <a href="javascript:void(0)" class="header-link nav-link" ngbDropdownToggle>
         {{username}} <b class="caret"></b>
      </a>
      <div style="margin-right: 1rem !important;right:0;left:auto" class="dropdown-menu" ngbDropdownMenu>
        <a class="dropdown-item" [routerLink]="['/user_profile']" >
          <i class="fa fa-fw fa-user"></i> {{t('my_profile')}}
        </a>
        <a class="dropdown-item" [routerLink]="['/login']" (click)="onClickLoggedout()">
          <i class="fa fa-fw fa-power-off"></i> {{t('logout')}}
        </a>
      </div>
    </li>
  </ul>
</div>





</nav>





